import React, { useState, useEffect } from 'react';
import '../style/TariffsContent.css';

import { Link } from 'react-router-dom';
import { t } from 'i18next';
import phoneIcon from '../../../assets/icons/phone.svg';
import eyeIcon from '../../../assets/icons/eye.svg';
import doneIcon from '../../../assets/icons/done.svg';
import chatIcon from '../../../assets/icons/chat.svg';
import heartIcon from '../../../assets/icons/heart.svg';
import infoIcon from '../../../assets/icons/info.svg';
import min_icon from '../../../assets/icons/min_flash.svg';
import max_icon from '../../../assets/icons/max_flash.svg';
import opt_icon from '../../../assets/icons/opt_flash.svg';
import backicon from '../../../assets/icons/backicon.svg';

import { getUserInfo } from '../../../api/usercall';
import warning_icon from '../../../assets/icons/WarningCircle.svg';


const TariffsContent = ({ setActiveTab }) => {
    const [userBalance, setUserBalance] = useState(0);

    const handleBackClick = () => {
        setActiveTab(null);
};

    useEffect(() => {
        const fetchUserBalance = async () => {
            try {
                const response = await getUserInfo();
                setUserBalance(response.user.balance);
            } catch (error) {
                console.error("Failed to fetch user balance:", error);
            }
        };
        fetchUserBalance();
    }, []);

    return (
        <div className="profile_render_container tariffs_container">            <div className="tariffs_content_left_section">
                <div className="tariffs_info_card">
                    <img
                    src={backicon}
                    onClick={handleBackClick}
                    className="back_icon_mobile"
                    alt="back"
                />
                <h2 className="tariffs_info_title">{t('tariffsTitle')}</h2>
                    <p className="tariffs_info_description">{t('tariffsDescription')}</p>
                    
                    <div className="tariffs_features">
                        <div className="feature_item">
                            <img src={eyeIcon} alt="Views" />
                            <span>{t('tariffsFeature1')}</span>
                        </div>
                        <div className="feature_item">
                            <img src={phoneIcon} alt="Phone" />
                            <span>{t('tariffsFeature2')}</span>
                        </div>
                        <div className="feature_item">
                            <img src={heartIcon} alt="Likes" />
                            <span>{t('tariffsFeature3')}</span>
                        </div>
                        <div className="feature_item">
                            <img src={chatIcon} alt="Comments" />
                            <span>{t('tariffsFeature4')}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="tariffs_content_right_section">
                <div className="balance_card content_background">
                    <p>{t('yourBalance')}: <strong className="balance">{userBalance} {t('units')}</strong></p>
                    <div className="balance_card_second_text">
                        <img src={infoIcon} alt="info" />
                        <p>{t('tariffsBalanceText')}</p>
                    </div>
                </div>

                <div className="services-section">
                    <h2 className="content_background">{t('tariffsSectionTitle')}</h2>
                    <div className="services">
                        {[
                            {
                                name: t('minimalTitle'),
                                iconPath: min_icon,
                                units: 500,
                                price: '100 тг.',
                                promotionType: 0,
                                text1: t('minimalText1'),
                                text2: t('minimalText2'),
                                text3: t('minimalText3'),
                                key: 'minimalTitle',
                                isPopular: false,
                            },
                            {
                                name: t('optimalTitle'),
                                iconPath: opt_icon,
                                units: 1300,
                                price: '1 000 тг.',
                                promotionType: 1,
                                text1: t('optimalText1'),
                                text2: t('optimalText2'),
                                text3: t('optimalText3'),
                                key: 'optimalTitle',
                                isPopular: true,
                            },
                            {
                                name: t('maximalTitle'),
                                iconPath: max_icon,
                                units: 2800,
                                price: '1 500 тг.',
                                promotionType: 2,
                                text1: t('maximalText1'),
                                text2: t('maximalText2'),
                                text3: t('maximalText3'),
                                key: 'maximalTitle',
                                isPopular: false,
                            },
                        ].map((tariff, index) => (
                            <div key={index} className="content_background service_card">
                                <div>
                                    <h3 className="tariff_title">
                                        <img src={tariff.iconPath} alt='icon' />
                                        {tariff.name}
                                        {tariff.isPopular && <span className="popular_badge">{t('popular')}</span>}
                                    </h3>
                                    <div className="tariff_price_info">
                                        <p className="tariff_price">{tariff.price}</p>
                                        <p className="tariff_units">{tariff.units} {t('units')}</p>
                                    </div>
                                    <div className="package_card_info">
                                        <img src={doneIcon} alt="done" />
                                        <p>{tariff.text1}</p>
                                    </div>
                                    <div className="package_card_info">
                                        <img src={doneIcon} alt="done" />
                                        <p>{tariff.text2}</p>
                                    </div>
                                    <div className="package_card_info">
                                        <img src={doneIcon} alt="done" />
                                        <p>{tariff.text3}</p>
                                    </div>
                                </div>
                                {userBalance < tariff.units && (
                                    <div className="balance-warning">
                                        <img src={warning_icon} alt={'warning'} />
                                        <p>
                                            {t('notEnoughCredits')}{' '}
                                            <Link to="/profile#walletTopUp" className="topup-link">
                                                {t('topupBalance')}
                                            </Link>
                                        </p>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TariffsContent;

